import { motion } from "framer-motion";
import coco from "../../accests/mirissa/mirissa (4).jpeg"
import dol from "../../accests/mirissa/mirissa (2).jpeg"
import malu from "../../accests/mirissa/maluu.jpeg"
import miri from "../../accests/mirissa/mirissa (1).jpeg"
import miri1 from "../../accests/mirissa/mirissa (3).jpeg"
import tha from "../../accests/mirissa/tha.jpeg"

// Unsplash / example images
const heroImg =
    miri1; // Mirissa Whale
const whaleImg =
    dol;
const dolphinsImg =
    miri
const coconutHillImg =
   tha
const mirissaHarbour =
   miri1

export default function WhaleWatchingDayTour() {
    const highlights = [
        {
            title: "Whale & Dolphin Watching Tour",
            desc: "4-5 hour morning tour from Mirissa harbour to spot blue whales, sperm whales, killer whales, and pods of playful dolphins in their natural habitat.",
            img: dol,
        },
        {
            title: "Visit Coconut Tree Hill",
            desc: "Relax and take photos at Coconut Tree Hill, a stunning cliffside spot overlooking the Indian Ocean with towering palm trees.",
            img: coco,
        },
        {
            title: "Mirissa Fishing Harbour",
            desc: "The whale-watching tour starts at Mirissa Fishing Harbour around 6:30 AM. You’ll board a well-equipped boat with GPS, safety gear, comfortable seating, toilets, and breakfast. A trained crew ensures a safe and enjoyable journey into the deep sea.",
            img: malu,
        },
    ];

    const itinerary = [
        "6:30 AM – Depart from Mirissa Fishing Harbour",
        "Board the whale-watching boat with safety gear",
        "Sail into the Indian Ocean and spot whales and dolphins",
        "Light breakfast served on board",
        "Return via Koggala Stilt Fishermen for photos",
        "Relax at Unawatuna Beach",
        "Return to your hotel",
    ];

    const travelTips = [
        "Best time for whale watching: November to April",
        "Bring camera to capture amazing moments",
        "Unlimited mineral water bottles are provided",
        "Light breakfast served on board",
    ];

    return (
        <div className="pt-28 bg-gray-50">

            {/* HERO */}
            <motion.div
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                transition={{duration: 1}}
                className="relative h-[65vh]"
            >
                <img
                    src= {dol}
                    alt="Whale & Dolphin Watching in Mirissa"
                    className="w-full h-full object-cover brightness-75"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-6">
                    <motion.h1
                        initial={{y: -40, opacity: 0}}
                        animate={{y: 0, opacity: 1}}
                        transition={{duration: 1, delay: 0.3}}
                        className="text-5xl md:text-6xl font-bold drop-shadow-lg"
                    >
                        Whale & Dolphin Watching Tour
                    </motion.h1>
                    <motion.p
                        initial={{y: 40, opacity: 0}}
                        animate={{y: 0, opacity: 1}}
                        transition={{duration: 1, delay: 0.6}}
                        className="mt-4 max-w-3xl text-lg drop-shadow-md"
                    >
                        Experience a spectacular marine adventure in Mirissa, Sri Lanka. Witness
                        whales and dolphins in their natural habitat, and relax at Unawatuna Beach.
                    </motion.p>
                </div>
            </motion.div>

            {/* HIGHLIGHTS */}
            <section className="max-w-7xl mx-auto px-6 py-16">
                <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
                    Highlights
                </h2>
                <div className="grid md:grid-cols-3 gap-10">
                    {highlights.map((item, i) => (
                        <motion.div
                            key={i}
                            whileHover={{scale: 1.05}}
                            className="bg-white rounded-3xl shadow-lg overflow-hidden transition"
                        >
                            <img
                                src={item.img}

                                className="w-full h-64 object-cover"
                            />
                            <div className="p-6">
                                <h3 className="text-2xl font-semibold text-yellow-500 mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-gray-600 text-sm">{item.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* ITINERARY */}
            <section className="bg-gray-100 py-16">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-start">
                    {/* LEFT – ITINERARY LIST */}
                    <div>
                        <h2 className="text-3xl font-bold mb-10 text-gray-800">Detailed Itinerary</h2>
                        <ul className="space-y-4 text-gray-700 list-decimal list-inside">
                            {itinerary.map((step, index) => (
                                <motion.li
                                    key={index}
                                    initial={{x: -50, opacity: 0}}
                                    whileInView={{x: 0, opacity: 1}}
                                    transition={{duration: 0.5, delay: index * 0.1}}
                                    className="text-lg"
                                >
                                    {step}
                                </motion.li>
                            ))}
                        </ul>
                    </div>

                    {/* RIGHT – SMALL IMAGES */}
                    <div className="grid grid-cols-2 gap-4">
                        {[mirissaHarbour, whaleImg, dolphinsImg, coconutHillImg].map((img, i) => (
                            <motion.img
                                key={i}
                                src={img}
                                alt="Tour spot"
                                whileHover={{scale: 1.05}}
                                className="h-40 w-full object-cover rounded-2xl shadow-lg"
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* WHY CHOOSE THIS TOUR + CTA */}
            <section className="relative py-24 overflow-hidden">
                <div className="absolute inset-0">
                    <img
                        src={whaleImg}
                        alt="Why choose Whale Watching Tour"
                        className="w-full h-full object-cover scale-110 blur-md"
                    />
                    <div className="absolute inset-0 bg-black/60"></div>
                </div>

                <div className="relative max-w-6xl mx-auto px-6 text-white text-center">
                    <h2 className="text-3xl md:text-4xl font-bold mb-10">
                        Why Choose This Tour?
                    </h2>

                    <ul className="max-w-3xl mx-auto space-y-4 text-lg list-disc list-inside backdrop-blur-md bg-white/10 p-8 rounded-3xl shadow-xl">
                        <li>Whale-watching boat trip off Mirissa harbour</li>
                        <li>Spot blue whales, killer whales, sperm whales, and dolphins</li>
                        <li>Enjoy a swim at Unawatuna Beach</li>
                        <li>Visit the traditional stilt fishermen of Sri Lanka</li>
                        <li>Flexible timings with expert local guide</li>
                    </ul>

                    {/* CTA */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="mt-14"
                    >
                        <motion.a
                            whileHover={{ scale: 1.08 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Whale%20Watching%20Tour"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center px-14 py-4
        bg-yellow-500 text-black font-semibold text-lg
        rounded-full shadow-xl hover:bg-yellow-400
        transition-all duration-300"
                        >
                            Book Whale Watching Tour
                        </motion.a>

                        <p className="mt-4 text-sm text-gray-200">
                            📞 Custom tours • 🕒 Flexible timing • 🚗 Comfortable transport
                        </p>
                    </motion.div>

                </div>
            </section>

            {/* TRAVEL TIPS */}
            <section className="py-20 bg-gradient-to-b from-white to-gray-100">
                <div className="max-w-7xl mx-auto px-6">
                    {/* Title */}
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                            Travel Tips
                        </h2>
                        <p className="mt-3 text-gray-600 max-w-xl mx-auto">
                            Helpful tips to make your journey smooth, safe, and memorable.
                        </p>
                    </div>

                    {/* Tips */}
                    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                        {travelTips.map((tip, i) => (
                            <motion.div
                                key={i}
                                initial={{opacity: 0, y: 20}}
                                whileInView={{opacity: 1, y: 0}}
                                whileHover={{y: -6}}
                                transition={{duration: 0.4}}
                                viewport={{once: true}}
                                className="group bg-white/70 backdrop-blur-xl border border-gray-200 rounded-2xl p-6 shadow-md hover:shadow-xl transition-all"
                            >
                                {/* Icon */}
                                <div
                                    className="w-12 h-12 flex items-center justify-center rounded-xl bg-blue-50 text-blue-600 mb-4 group-hover:scale-110 transition">
                                    ✈️
                                </div>

                                {/* Content */}
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                    {tip.split("•")[0]}
                                </h3>
                                <p className="text-sm text-gray-600 leading-relaxed">
                                    {tip}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>


            {/* BOOK CTA */}

        </div>
    );
}
